import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  revokeFeedbackCollectionApiService,
  type RevokeFeedbackCollectionRequest,
  type RevokeFeedbackCollectionResult,
} from "@/generated/fastapi";

export async function revokeFeedbackLink(
  accessToken: string | null | undefined,
  request: RevokeFeedbackCollectionRequest,
): Promise<RevokeFeedbackCollectionResult> {
  const response = await revokeFeedbackCollectionApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to revoke feedback link (${response.status})`);
  }

  if (response.data.status !== "success") {
    throw new Error(response.data.message || "Failed to revoke feedback link");
  }

  return response.data;
}
